module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_sentrert_logo_stor_pos.8de5c355.png";